export const getSingleTest = (payload?: any) => ({
    type: "@saga/GET_SINGLE_TEST",
    payload
});

